module.exports = __webpack_public_path__ + "static/mongo-60621585d2ba69986c44bdef2710ea60.png";